export const defaultLandingType = 'default'
export const threeFeaturesLandingType = 'three-features'
